/**
 * Carousel
 *
 * Adds a carousel effect to the partner logos on the home page using jQuery
 * Cycle 2 and the jQuery Cycle 2 Carousel plugin. Resets the carousel on window
 * resize to adjust the number of items visible.
 */
$(function() {
    var carousels = $('.page-home-partners .logos .wrap');
    var visible;

    if (carousels.length === 0) {
        return;
    }

    // Determine the number of items we should show at a time based on the
    // current screen width.
    visible = function() {
        var width = $(window).width();
        var breakpoints = {
            1: 640,
            2: 960,
            3: 1280,
            4: 1600
        };

        for (var key in breakpoints) {
            if (width < breakpoints[key]) {
                return key;
            }
        }

        return 6;
    };

    // Loop through each carousel on the page, add the previous and next
    // controls, initialize the carousel, and re-initialize the carousel when
    // the window resizes.
    carousels.each(function(i, element) {
        var carousel = $(element);

        // Function to initialize the carousel effect, using the visible
        // function to set the number of items visible based on the screen size.
        // The carousel effect requires the Cycle 2 Carousel plugin.
        var init = function() {
            carousel.cycle({
                speed: 1000,
                timeout: 3500,
                slides: '> .logo',
                fx: 'carousel',
                carouselVisible: visible(),
                carouselFluid: true,
                prev: carousel.siblings('.prev'),
                next: carousel.siblings('.next'),
                log: false
            });
        };

        // Start the carousel on page load
        init();

        // It is impossible to change the carousel settings individually on the
        // fly, so this destroys and recreates the carousel from scratch when
        // the window has finished resizing.
        $(window).on('resizeDone', function() {
            carousel.cycle('destroy');
            init();
        });
    });
});
